import React from 'react';
import serviceProvider from '../../services/axios'
import { useEffect, useState } from "react";
import { useHistory, Link, Redirect } from "react-router-dom";
import { TaskCenterView } from './TaskCenterView';
export const TaskCenterController = (props) => {
   

	  const [results, setResults] = useState([]);
	  const user = JSON.parse(localStorage.getItem("userData"));
	  const usid = user ? user.uid : 0;
	  const gid = user ? user.group_id : 0;
	  const urlParams = new URLSearchParams(window.location.search);
	  const [filter, setFilter] = useState(urlParams.get('filter'));
     
	  useEffect(() => {
			const search = async () => {
				const apiUrl = `/taskcenters?param=task&uid=${usid}&gid=${gid}`;
				const { data } = await serviceProvider.get(apiUrl,true,{});
				setResults(data);
			};
			search();
		}, []);
    return (
        <>
            <TaskCenterView result={results} onfilter={filter} setFilter={setFilter}  {...props} />
        </>
    );
}

